import { memo } from "react"

// ** Third Party Components
import { X } from "lucide-react"
import { useNavigate } from "react-router-dom"

// ** Routes
import { NEW_DASHBOARD_PAGE_ROUTE } from "@pma/utils/page-routes"

interface NavbarHeaderProps {
  onClose: () => void
}

const NavbarHeader = ({ onClose }: NavbarHeaderProps) => {
  const navigate = useNavigate()

  return (
    <div className='flex items-center justify-between p-4 pb-2'>
      <div
        className='flex cursor-pointer items-center gap-2'
        onClick={() => navigate(NEW_DASHBOARD_PAGE_ROUTE, { replace: true })}
      >
        <div className='flex h-6 w-6 items-center justify-center rounded bg-gray-800'>
          <span className='text-xs font-bold text-white'>R</span>
        </div>
        <span className='font-semibold text-gray-900'>ROG</span>
      </div>
      {onClose && (
        <button onClick={onClose} className='rounded p-1 hover:bg-gray-100 lg:hidden'>
          <X />
        </button>
      )}
    </div>
  )
}

export default memo(NavbarHeader)
